module.exports = __webpack_public_path__ + "img/guanyu.7cf7581f.png";